import { addLogToReport, externalRedirect } from '@americanexpress/one-app-ducks';
import {
  HEADER_PWB_JWT_TOKEN,
  HEADER_TRACKING_ID,
  VRP_DASHBOARD_GET_VRP_DETAILS,
} from '../constants/apiConstants';
import { STORE_CONFIG } from '../constants/appConstants';
import { getClientContext } from '../utils/deviceUtils';

const GET_VRP_DETAILS_REQUEST = 'vrp-dashboard/GET_VRP_DETAILS_REQUEST';
const GET_VRP_DETAILS_SUCCESS = 'vrp-dashboard/GET_VRP_DETAILS_SUCCESS';
const GET_VRP_DETAILS_FAILURE = 'vrp-dashboard/GET_VRP_DETAILS_FAILURE';

const buildGetVrpDetailsRequest = (trackingId, xPwbJwtToken) => ({
  method: 'GET',
  credentials: 'include',
  headers: {
    ...trackingId ? { [HEADER_TRACKING_ID]: trackingId } : {},
    ...xPwbJwtToken ? { [HEADER_PWB_JWT_TOKEN]: xPwbJwtToken } : {},
  },
});

export const getVrpDetails = ({
  apiUrl, trackingId, xPwbJwtToken, fetchClient,
}) => async (dispatch, getState) => {
  dispatch({ type: GET_VRP_DETAILS_REQUEST });
  const loginUrl = getState().getIn([STORE_CONFIG, 'loginUrl']);

  try {
    dispatch(addLogToReport('info', 'get vrp request details', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      apiPath: VRP_DASHBOARD_GET_VRP_DETAILS,
      PWB_JWT_TOKEN: xPwbJwtToken,
      trackingId,
      ...getClientContext(),
    }));
    const request = buildGetVrpDetailsRequest(trackingId, xPwbJwtToken);
    const response = await fetchClient(`${apiUrl}${VRP_DASHBOARD_GET_VRP_DETAILS}`, request);

    let body = null;
    try {
      body = await response.json();
    } catch {
      body = null;
    }

    if (!response.ok) {
      if (response.status === 401) {
        dispatch(addLogToReport('info', 'Get VRP details request unauthorised - redirecting to login', {
          moduleID: 'axp-bank-permissions-dashboard-root',
          apiPath: VRP_DASHBOARD_GET_VRP_DETAILS,
          status: response.status,
          ...getClientContext(),
        }));
        dispatch(externalRedirect(loginUrl));
        return { ok: false, status: 401 };
      }

      const message = body?.status_message
        || body?.message
        || 'Failed to fetch VRP details. Please try again later';

      dispatch(addLogToReport('info', 'get vrp request failed', {
        moduleID: 'axp-bank-permissions-dashboard-root',
        type: GET_VRP_DETAILS_FAILURE,
        trackingId: response.headers?.get(HEADER_TRACKING_ID),
        status: response.status,
        response,
        ...getClientContext(),
      }));
      dispatch({ type: GET_VRP_DETAILS_FAILURE, payload: message });
      return { ok: false, status: response.status, message };
    }
    const updatedXPwbJwtToken = response.headers?.get(HEADER_PWB_JWT_TOKEN);
    const updatedTrackingId = response.headers?.get(HEADER_TRACKING_ID);
    dispatch(addLogToReport('info', 'get vrp request success', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      type: GET_VRP_DETAILS_SUCCESS,
      trackingId: response.headers?.get(HEADER_TRACKING_ID),
      status: response.status,
      response,
      ...getClientContext(),
    }));
    dispatch({
      type: GET_VRP_DETAILS_SUCCESS,
      payload: {
        status: response.status,
        body,
        trackingId: updatedTrackingId || trackingId,
        xPwbJwtToken: updatedXPwbJwtToken,
      },
    });
    return {
      ok: true, status: response.status, body, xPwbJwtToken: updatedXPwbJwtToken,
    };
  } catch (error) {
    const message = error?.message || 'Failed to fetch VIP details. Please try again later';
    dispatch(addLogToReport('info', 'get vrp request failed', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      type: GET_VRP_DETAILS_FAILURE,
      trackingId: error.headers?.get(HEADER_TRACKING_ID),
      status: error.status,
      error,
      ...getClientContext(),
    }));
    dispatch({ type: GET_VRP_DETAILS_FAILURE, payload: message });
    return { ok: false, status: null, message };
  }
};

export {
  GET_VRP_DETAILS_REQUEST,
  GET_VRP_DETAILS_SUCCESS,
  GET_VRP_DETAILS_FAILURE,
};
